import { h, Component } from 'preact';

import { showModal } from 'utils/modal';

import Button from 'components/button/button';
import Image from 'components/image/image';
import Pin from 'components/icons/pin';

import s from 'components/media/focalPointSelector.sss';

export default class FocalPointSelector extends Component {
	constructor(props) {
		super(props);

		this.state = { focalPoint: props.focalPoint || null };
		
		this.cancel = this.cancel.bind(this);
		this.reset = this.reset.bind(this);
		this.setFocalPoint = this.setFocalPoint.bind(this);
		this.handlePointerDown = this.handlePointerDown.bind(this);
		this.handlePointerMove = this.handlePointerMove.bind(this);
		this.handlePointerUp = this.handlePointerUp.bind(this);
	}

	cancel() {
		this.base.close('CANCEL');
	}

	reset() {
		this.setState({ focalPoint: null });
	}

	setFocalPoint() {
		const { focalPoint } = this.state;
		this.base.close(JSON.stringify(focalPoint));
	}


	// ---------------------------------------------------
	// MOUSE EVENT PROCESSING
	// ---------------------------------------------------

	updateFocalPoint(e) {
		if (!this.$img) return;
		const { clientX, clientY } = e;
		const { left, top, width, height } = this.$img.getBoundingClientRect();
		const focalX = Math.max(0, Math.min(1, (clientX - left) / width));
		const focalY = Math.max(0, Math.min(1, (clientY - top) / height));
		this.setState({ focalPoint: { focalX, focalY } });
	}

	handlePointerDown(e) {
		e.preventDefault();
		this.dragging = true;
		e.target.setPointerCapture(e.pointerId);
		this.updateFocalPoint(e);
	}

	handlePointerMove(e) {
		if (!this.dragging) return;
		e.preventDefault();
		this.updateFocalPoint(e);
	}

	handlePointerUp() {
		this.dragging = false;
	}


	// ---------------------------------------------------
	// RENDERING
	// ---------------------------------------------------

	renderPreview(title, aspectRatio) {
		const { focalPoint } = this.state;
		const [width, height] = aspectRatio.split(':').map(Number);
		const style = { width: 150, height: 150 * (height / width) };
		return (
			<div class={s.preview}>
				<div class={s.previewTitle}>{title}</div>
				<Image 
					src={this.props.imgSrc || this.props.file?.s3_url} 
					alt={title} 
					style={style} 
					focalPoint={focalPoint} 
				/>
			</div>
		);
	}

	render() {
		const imgSrc = this.props.imgSrc || this.props.file?.s3_url;
		const { focalPoint } = this.state;
		return (
			<dialog class={s.wrapper} id="focusPointModal">
				<Button class={s.close} icon="cancel" iconSize="large" onClick={this.cancel} />
				<div class={s.step}>
					<h2>Set focal point</h2>
					<p>Click to pin a specific point in the image to keep it visible when the screen size changes</p>
					<div class={s.imageContainer}>
						<img
							ref={el => (this.$img = el)}
							class={s.interactiveImage}
							src={imgSrc}
							onPointerDown={this.handlePointerDown}
							onPointerMove={this.handlePointerMove}
							onPointerUp={this.handlePointerUp}
						/>
						{focalPoint && (
							<Pin 
								class={s.pin} 
								style={{ 
									left: `${focalPoint.focalX * 100}%`, 
									top: `${focalPoint.focalY * 100}%` 
								}}
								onPointerDown={this.handlePointerDown}
								onPointerMove={this.handlePointerMove}
								onPointerUp={this.handlePointerUp}
							/>
						)}
					</div>
					<details>
						<summary>Previews</summary>
						<div class={s.previewsRow}>
							{this.renderPreview('Hero (desktop)', '16:9')}
							{this.renderPreview('Hero (mobile)', '1:1')}
							{this.renderPreview('Movie page', '241:75')}
							{this.renderPreview('Share image', '1920:960')}
						</div>
					</details>
					<div class={s.buttonRow}>
						<Button onClick={this.reset}>Reset</Button>
						<Button primary onClick={this.setFocalPoint}>Set focal point</Button>
					</div>
				</div>
			</dialog>
		);
	}
}

export async function showFocalPointSelector(options) {
	const data = await showModal(FocalPointSelector, options);
	if (!data || data === 'CANCEL') return data || null;
	try {
		return JSON.parse(data);
	} catch {}
	return null;
}